import { mensagemPadrao } from 'src/dados-estaticos'
import * as Yup from 'yup'
export const schema = Yup.object().shape({
  disciplina: Yup.string().required(mensagemPadrao)
})
